import { render, staticRenderFns } from "./plan-affiliations-form.vue?vue&type=template&id=46f48d58&scoped=true"
import script from "./plan-affiliations-form.vue?vue&type=script&lang=ts"
export * from "./plan-affiliations-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f48d58",
  null
  
)

export default component.exports